// extracted by mini-css-extract-plugin
export default {"list":"Settings_list__xK77-"};